import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-info-tooltip',
  standalone: true,
  imports: [CommonModule],
  host: {
    'ngSkipHydration': 'true',
    'class': 'inline-flex items-center shrink-0 self-center leading-none',
  },
  template: `
  <div class="relative inline-flex items-center justify-center group" (click)="$event.stopPropagation()">
    <button
      type="button"
      [class]="'inline-flex shrink-0 items-center justify-center rounded-full border-0 bg-transparent text-text-dimmed hover:text-text-primary focus-visible:ring-2 focus-visible:ring-text-brand/60 cursor-help transition-colors ' + sizeClass()"
    >
      <span class="inline-flex min-w-0 shrink-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          [attr.width]="svgSize()"
          [attr.height]="svgSize()"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="pointer-events-none block shrink-0"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M12 16v-4" />
          <path d="M12 8h.01" />
        </svg>
      </span>
    </button>
    <div
      [style.width]="width()"
      [class]="'absolute px-3 py-2 bg-side-navigation-panel-default-bg border border-card-border-border rounded-lg shadow-2xl text-[10px] text-text-primary whitespace-normal pointer-events-none hidden group-hover:block group-focus-within:block transition-all duration-200 z-50 ' + positionClasses() + ' ' + alignClasses()"
    >
      <div class="relative z-10">
        {{ text() }}
      </div>
      <div [class]="'absolute w-2 h-2 bg-side-navigation-panel-default-bg border-card-border-border rotate-45 ' + arrowClasses() + ' ' + arrowAlignClasses()"></div>
    </div>
  </div>
`,
  styles: ``
})
export class InfoTooltipComponent {
  text = input.required<string>();
  size = input<'sm' | 'xs'>('sm');
  width = input<string>('240px');
  position = input<'top' | 'bottom'>('top');
  align = input<'center' | 'left' | 'right'>('center');

  sizeClass(): string {
    return this.size() === 'xs'
      ? 'p-0.5'
      : 'p-0.5';
  }

  svgSize(): number {
    return this.size() === 'xs' ? 12 : 14;
  }

  positionClasses(): string {
    return this.position() === 'bottom'
      ? 'top-full mt-2'
      : 'bottom-full mb-2';
  }

  alignClasses(): string {
    switch (this.align()) {
      case 'right':
        return 'right-0';
      case 'left':
        return 'left-0';
      default:
        return 'left-1/2 -translate-x-1/2';
    }
  }

  arrowClasses(): string {
    return this.position() === 'bottom'
      ? 'bottom-full -mb-1 border-l border-t'
      : 'top-full -mt-1 border-r border-b';
  }

  arrowAlignClasses(): string {
    switch (this.align()) {
      case 'right':
        return 'right-2.5';
      case 'left':
        return 'left-2.5';
      default:
        return 'left-1/2 -translate-x-1/2';
    }
  }
}